import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContextMenu = _resolveComponent("ContextMenu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.cmOpener.open($event, _ctx.id)), ["prevent","stop"])),
      class: _normalizeClass(_ctx.buttonClass)
    }, _cache[1] || (_cache[1] = [
      _createElementVNode("i", { class: "block text-center icon-opzioni" }, null, -1)
    ]), 2),
    (_openBlock(), _createBlock(_Teleport, { to: _ctx.teleport_to }, [
      _createVNode(_component_ContextMenu, {
        id: _ctx.id,
        "menu-class": _ctx.menuClass,
        cmOpener: _ctx.cmOpener
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["id", "menu-class", "cmOpener"])
    ], 8, ["to"]))
  ], 64))
}